import { domain } from '../config/AppConfigurator';

export const getAddressList = async (fuelTypeId, postcode, accessToken, userAuthorization)=>{
    const response = await fetch(`${domain}/request/Address/recco?` + new URLSearchParams({
        fuelTypeId: JSON.stringify(fuelTypeId) ,
        postcode: postcode,
    }), {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
            'User-Authorization': `${userAuthorization}`
          },
    })
    return response.json();
}